import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Icon,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { useApiError } from "../../../../common/errors/useApiError";
import { useSaveOrganization } from "../useOrganizationEditor";

interface FormValues {
  specializations: string;
}
interface Props {
  currentValue: string;
}

export const ChangeSpecializations = ({ currentValue }: Props) => {
  const { saveOrganization, isSaving } = useSaveOrganization();
  const toast = useToast();
  const { t } = useTranslation();
  const displayer = useApiError();

  const {
    formState: { errors },
    register,
    handleSubmit,
    watch,
  } = useForm<FormValues>({
    defaultValues: {
      specializations: currentValue,
    },
  });

  const newValue = watch("specializations");
  const onSubmit = async (values: FormValues) => {
    try {
      await saveOrganization({ specializations: { value: values.specializations } });
      toast({
        title: t("Company specializations has been updated!"),
        status: "success",
      });
    } catch (e) {
      displayer.trigger(e);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl mt="15px" isInvalid={errors.specializations !== undefined}>
          <FormLabel htmlFor={"specializations"}>{t("Specializations")}</FormLabel>
          <Textarea
            {...register("specializations", {
              minLength: {
                value: 2,
                message: t("Must be at least 2 characters long"),
              },
            })}
          />
          <FormErrorMessage>{errors.specializations && errors.specializations.message}</FormErrorMessage>
          <FormHelperText>{t("Please give a short description of your company's specializations")}.</FormHelperText>
        </FormControl>
        {currentValue.trim() !== newValue.trim() && (
          <Button
            mt="10px"
            leftIcon={<Icon as={FaSave} w="15px" h="15px" mt="-2px" />}
            variant={"solid"}
            colorScheme="teal"
            size={"sm"}
            isLoading={isSaving}
            type="submit"
          >
            {t("Save change")}
          </Button>
        )}
      </form>
    </>
  );
};
